let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eCZgn")).then(() => parcelRequire('dUI4N'));